import logoImage from '../../images/logo.svg';
import PmsUrlConfig from '../../urlConfig';
import { useNavigate } from "react-router-dom";

export default function SignUpHeader() {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-center px-4 sm:px-6 lg:px-8 h-full bg-white">
      <div className="flex items-center flex-shrink-0">
        <div 
            className="h-[50px] w-[80px] bg-cover bg-center"
            style={{ backgroundImage: `url(${logoImage})` }}
        ></div>
      </div>
      <div className="flex-1 text-center px-2 sm:px-4 min-w-0 hidden sm:block">
        <h1 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 truncate">Practice Management System</h1>
      </div>
      <div className="flex-shrink-0">
        <button
          onClick={() => { navigate(`${PmsUrlConfig.HOME_URL}`) }}
          className="px-3 py-1.5 sm:px-4 sm:py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 text-sm sm:text-base"
        >
          Login
        </button>
      </div>
    </div>
  );
}